import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/evaluators/form'
import { api, actionCreators } from 'store/modules/evaluators'

const metadata = {
  icon: 'align-justyfy',
  page: 'evaluators',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
